import { React, useEffect, useState } from "react";
import Background from "../../Background";
import {
  Avatar,
  Box,
  Flex,
  FormLabel,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { ModalComponent } from "../../../Components/Common/UI";
import Api from "../../..//Helper/ApiHandler";
import { FriendListModal } from "./FriendListModal";
import { useParams } from "react-router-dom";
import AlbumTab from "./AlbumTab";
import TableLoader from "../../../Components/Common/TableLoader";
import PhotoBookTab from "./PhotobookTab";
import placeHolder from "../../../Assets/profile_placeholder.jpg";

const UserProfile = () => {
  const api = new Api();
  const [isFriendModalOpen, setisFriendModalOpen] = useState(false);
  const handleFriendModalClose = async () => {
    setisFriendModalOpen(false);
    // await refetch();
  };
  const [userdata, setUserData] = useState();
  const [userdata1, setUserData1] = useState();
  const [isLoading, setIsLoading] = useState(false);
  let { id } = useParams();

  const getcardData = async () => {
    setIsLoading(true);
    let { data } = await api.post(`${"user/get-card-data"}`, {
      userId: id,
    });
    setIsLoading(false);
    setUserData(data[0][0]);
    setUserData1(data[1][0]);
  };

  useEffect(() => {
    getcardData();
  }, [id]);
  return (
    <Background heading={"User Profile"} key="user-management" showBack="true">
      <Flex flexDirection={"row"} height={"90%"} gap={"4"}>
        <Box
          flex={1}
          display={"flex"}
          flexDirection={"column"}
          backgroundColor={"#FFFFFF"}
          borderRadius={"12px"}
          position={"relative"}
        >
          <TableLoader isLoading={isLoading} version={6} />
          {!isLoading ? (
            <Box paddingLeft={"20px"}>
              <Box>
                <Box>
                  <Avatar
                    name={"sauravb"}
                    src={userdata?.profilePhotoUrl || placeHolder}
                    size={"xl"}
                    marginTop={"8"}
                  />
                </Box>
                <Box marginTop={"10px"}>
                  <Box fontSize={"20px"} fontWeight={"bold"}>
                    {userdata?.firstName ??
                      "fn" + " " + userdata?.lastName ??
                      "ln"}
                  </Box>
                  <Box fontSize={"15px"}>{userdata?.userName ?? "-"}</Box>
                </Box>
                <Box color={"#5E5E5E"}>{userdata?.bio}</Box>
              </Box>

              <Box
                display={"flex"}
                marginLeft={"2px"}
                marginRight={"8px"}
                marginTop={"25px"}
              >
                <Box>
                  <Box>{userdata?.albumDataCount ?? "0"}</Box>
                  <Box fontWeight={"bold"}>Albums</Box>
                </Box>
                <Box marginLeft={"30px"}>
                  <Box>{userdata?.photobookCount ?? "0"}</Box>
                  <Box fontWeight={"bold"}>photobook</Box>
                </Box>
              </Box>
              <Box marginTop={"10px"}>
                <Box> {userdata1?.totalCount[0]?.count ?? "0"}</Box>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  onClick={() => {
                    setisFriendModalOpen(true);
                  }}
                  cursor="pointer"
                >
                  <Box
                    marginTop={"5px"}
                    fontWeight="bold"
                    backgroundColor={"#1CBAA7"}
                    color={"white"}
                    borderRadius={"10px"}
                    padding={"6px"}
                  >
                    Friends
                  </Box>
                  {/* <Info size={"20"} /> */}
                </Box>
              </Box>
              <Box display={"flex"} marginTop={"20px"} flexDirection={"column"}>
                <Box>
                  <FormLabel marginTop={"7px"} fontWeight={"semibold"}>
                    Email
                  </FormLabel>

                  <Text>{userdata?.email ?? "-"}</Text>
                </Box>
                <Box>
                  <FormLabel marginTop={"7px"} fontWeight={"semibold"}>
                    contact
                  </FormLabel>

                  <Text>{userdata?.contact ?? "-"}</Text>
                </Box>
              </Box>
            </Box>
          ) : (
            ""
          )}
        </Box>
        <Box
          id="mainSide"
          flex={3}
          borderRadius={"12px"}
          backgroundColor={"#FFFFFF"}
        >
          <Tabs variant="enclosed">
            <TabList>
              <Tab>Albums</Tab>
              <Tab>Photobook</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <AlbumTab Id={id} />
              </TabPanel>
              <TabPanel>
                <PhotoBookTab />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
        <ModalComponent
          isOpen={isFriendModalOpen}
          onClose={handleFriendModalClose}
          size="lg"
        >
          <FriendListModal Id={id} onClose={handleFriendModalClose} />
        </ModalComponent>
      </Flex>

      {/* <UserDetails /> */}
    </Background>
  );
};

export default UserProfile;
